<template>
  <div id="SysLoginLogList">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <el-form
      :model="listRequestData"
      label-width="80px"
      :inline="true"
      class="demo-form-inline form"
    >
      <el-form-item label="联系电话">
        <el-input
          class="eb-input"
          v-model="listRequestData.userPhone"
          placeholder="联系电话"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="真实姓名"
        prop="trueName"
      >
        <el-input
          class="eb-input"
          v-model="listRequestData.trueName"
          placeholder="真实姓名"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="机构名称"
        prop="showName"
      >
        <el-input
          class="eb-input"
          v-model="listRequestData.orgName"
          placeholder="机构名称"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-form
      :model="listRequestData"
      label-width="80px"
      :inline="true"
      class="demo-form-inline"
    >
      <el-form-item label="登录时间">
        <el-date-picker
          v-model="listRequestData.loginTimeStart"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="开始日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        label="-"
        label-width="6px"
      >
        <el-date-picker
          v-model="listRequestData.loginTimeEnd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          class="eb-button-group-btn eb-button-orange button"
          @click="submitForm"
        >搜索</el-button>
        <el-button
          class="eb-button-group-btn eb-button-orange button"
          @click="resetForm"
        >重置</el-button>
        <!--<el-button
          class="eb-button-group-btn eb-button-orange button"
          @click="deleteLoginLog"
        >删除</el-button>-->
      </el-form-item>
    </el-form>
    <div class="table eb-table">
      <el-table
        :data.sync="pageData"
        tooltip-effect="dark"
        style="width: 100%"
        @sort-change="sortChange"
        row-key="loginLogId"
        @selection-change="listUserHandleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          :reserve-selection="true"
        >
        </el-table-column>
        <el-table-column
          prop='userPhone'
          label="联系电话"
          width="110"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop='trueName'
          label="真实姓名"
          width="100"
          sortable="custom"
        >
          <template slot-scope="scope">
            <a
              @click="showUserInfo(scope.row)"
              href="javascript:void(0)"
              class="a-font-red"
            >{{scope.row.trueName}}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop='orgName'
          label="机构名称"
          sortable="custom"
          min-width="110"
        ></el-table-column>
        <el-table-column
          prop='roleName'
          label="角色名称"
          width="120"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop='loginTime'
          label="登录时间"
          sortable="custom"
          min-width="110"
        >
          <template slot-scope="scope">
            {{loginTime(scope.row.loginTime)}}
          </template>
        </el-table-column>
        <el-table-column
          prop='type'
          label="登录类型"
          width="100"
          sortable="custom"
        >
          <template slot-scope="scope">
            {{loginType(scope.row.type)}}
          </template>
        </el-table-column>
        <el-table-column
          prop='status'
          label="登录状态"
          width="100"
          sortable="custom"
        >
          <template slot-scope="scope">
            {{loginStatus(scope.row.status)}}
          </template>
        </el-table-column>
        <el-table-column
          prop='ipAddress'
          label="登录IP"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop='browser'
          label="浏览器"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop='os'
          label="操作系统"
          sortable="custom"
        ></el-table-column>
      </el-table>
      <eb-pagination
        :current-page.sync="listRequestData.start"
        v-if="recordsTotal"
        @current-change="paginationData"
        :total="recordsTotal"
      />
    </div>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import { getLoginLogs, deleteLoginLog } from '@/services/system-service';
import { clone } from 'lodash';
import eventBus from '@/plugins/event-bus';
import moment from 'moment';
export default {
  name: 'SysLoginLogList',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebPagination
  },
  data() {
    let startTime = moment()
      .subtract(6, 'days')
      .format('YYYY-MM-DD');
    let endTime = moment().format('YYYY-MM-DD');
    return {
      loading: true,
      pageData: [],
      recordsTotal: null,
      listRequestData: {
        start: 1,
        length: 10,
        orderProp: 'loginTime',
        orderType: 'desc',
        userPhone: '',
        trueName: '',
        orgName: '',
        loginTimeStart: startTime,
        loginTimeEnd: endTime
      },
      initParams: {},
      listLoginLofArr: []
    };
  },
  created() {
    this.initParams = clone(this.listRequestData);
    this.initLoginLogs();
  },
  methods: {
    async initLoginLogs() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await getLoginLogs(this.listRequestData);
        if (data.returnCode === '01') {
          this.pageData = data.data;
          this.recordsTotal = data.recordsTotal;
        } else {
          this.$message.error('查询登录日志失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
      this.$root.layout.isLoading = false;
    },
    loginType(type) {
      return this.$options.filters['loginType'](type);
    },
    loginStatus(status) {
      return this.$options.filters['loginStatus'](status);
    },
    loginTime(time) {
      return this.$options.filters['dateTimeStandardFormat'](time);
    },
    showUserInfo(row) {
      eventBus.$emit('userInfoDialog', row.userId);
    },
    sortChange(columnData) {
      this.listRequestData.orderProp = columnData.prop;
      switch (columnData.order) {
        case 'descending':
          this.listRequestData.orderType = 'desc';
          break;
        case 'ascending':
          this.listRequestData.orderType = 'asc';
          break;
      }
      this.initLoginLogs();
    },
    // 分页
    paginationData(pageNum) {
      this.listRequestData.start = pageNum;
      this.initLoginLogs();
    },
    resetForm: function() {
      this.listRequestData = clone(this.initParams);
      this.initLoginLogs();
    },
    submitForm() {
      this.initLoginLogs();
    },
    // 改变选择用户数组
    listUserHandleSelectionChange: function(rows) {
      this.listLoginLofArr = [];
      rows.forEach(element => {
        if (element.isCheck !== '1') {
          this.listLoginLofArr.push(element.loginLogId);
        }
      });
    },
    // 删除登录日志
    async deleteLoginLog() {
      if (this.listLoginLofArr.length === 0) {
        this.$message.error('请选择数据');
        return false;
      }
      let loginLogIds = this.listLoginLofArr.join(',');
      this.$root.layout.isLoading = true;
      try {
        let { data } = await deleteLoginLog(loginLogIds);
        if (data.returnCode === '01') {
          this.initLoginLogs();
          this.$message.success('操作成功');
        } else {
          this.$message.error('删除失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
      this.$root.layout.isLoading = false;
    }
  }
};
</script>
<style lang="less" scoped>
#SysLoginLogList {
  .form {
    max-width: 100%;
    margin-top: 30px;
  }
  .table {
    padding: 10px 10px;
    max-width: 100%;
    margin-bottom: 20px;
  }
  .button {
    height: 35px;
    width: 80px;
  }
  .a-font-red {
    color: #fb5b3b;
  }
}
</style>
